import { isBrowser } from 'ws-scripts/modules/environment';

/**
 * Get the current environment based on hostname
 * @returns {'localhost' | 'nonprod' | 'prod'} The current environment
 */
export const getEnv = () => {
	if (!isBrowser) {
		return 'localhost';
	}
	if (window.location.hostname.includes('web-prod')) {
		return 'prod';
	} else if (window.location.hostname.includes('web-np')) {
		return 'nonprod';
	} else {
		return 'localhost';
	}
};
